export default "__VITE_ASSET__545c36b7__"